import axios from 'axios';
import { SessionStorageKeys } from './sessionStorageKeys.const';

export default class FeatureSettingsService {
    static isFeatureEnabled(featureKey) {
        try {
            let featuresJson = sessionStorage.getItem(SessionStorageKeys.featureSettings);
            let features = JSON.parse(featuresJson);
            if (features[featureKey]) {
                return features[featureKey].active;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    }


    static init(shouldResetCache) {
        if (sessionStorage.getItem(SessionStorageKeys.featureSettings) && !shouldResetCache) {
            return Promise.resolve();
        }

        return axios.get(process.env.baseHref + '/api/online/v1/feature-settings')
            .then((response) => {
                const features = {};
                const featuresArray = response.data;
                featuresArray.forEach((feature) => {
                    features[feature.key] = feature
                });
                
                sessionStorage.setItem(SessionStorageKeys.featureSettings, JSON.stringify(features));                   

                return Promise.resolve();
            });
    }
}



// WEBPACK FOOTER //
// ./src/scripts/services/featureSettingsService.js